import { queryOptions, useQuery } from '@tanstack/react-query'

import { getHodDirectory } from '../api/hodApi'

/** Department→HOD directory for the Issues toolbar's HOD filter. Changes rarely (org chart), so a
 *  long staleTime; the picker degrades gracefully to department-name labels while loading. */
export const hodDirectoryQueryOptions = () =>
  queryOptions({
    queryKey: ['gis', 'hod-directory'] as const,
    queryFn: () => getHodDirectory(),
    staleTime: 1000 * 60 * 30,
  })

export function useHodDirectory() {
  return useQuery(hodDirectoryQueryOptions())
}
